import React, { useContext, useEffect, useRef, useState } from 'react';
import { Card, CardBody } from 'reactstrap';
import BranchMappingListing from './BranchMappingListing';
import { ReactComponent as DownArrow } from "assets/img/svg/downarrow.svg"
import { ReactComponent as Uparrow } from "../../../../../../assets/img/svg/upwardArrow.svg";
import { RolePermissions } from 'appContext';
import { PermissionContext } from 'appContext';
import { pages } from 'views/pages/manage/common/constant';
import { array } from 'prop-types';
import { getUniqueDropdown } from './constant';
const BranchMapping = ({ dropdown,
    setBranchMappingRows,
    branchMappingRows,
    rowForm,
    setRowForm,
    activeContactRows,
    basicForm,
    editSaveHandler,
    isView
}) => {
    const [currentPage, setCurrentPage] = useState(0);
    const [rowCount, setRowCount] = useState(0);
    const [isNew, setIsNew] = useState(false)
    const [open, setOpen] = useState(true)
    const [tempBuDropdown, setTempBuDropdown]= useState()
    const listRef = useRef()
    const userPermissions = RolePermissions(
        useContext(PermissionContext),
        pages["schoolMaster"]["id"]
    );
    useEffect(()=>{
        const getBuDropdown=()=>{
        const tempBuList=getUniqueDropdown(dropdown?.businessArea??[],branchMappingRows,'bu')
        setTempBuDropdown(tempBuList)
        }
        branchMappingRows&&dropdown?.businessArea&&getBuDropdown()
    },[branchMappingRows,dropdown?.businessArea])
    
    const createHandler = (rowForm) => {
        isView && editSaveHandler(basicForm,rowForm,
            {
            isBasicFieldsChanged:false,
            isContactsChanged:false,
            isBranchMappingChanged:true
        })
        setBranchMappingRows((prev) => ([{ ...rowForm, isNew: false }, ...prev]))
        listRef.current.stopEditing();
    }
    const updateHandler = (rowForm) => {
        const index = branchMappingRows.findIndex(item => item.id === rowForm?.id);

        if (index !== -1) {
            let tempList = [...branchMappingRows]
            tempList[index] = { ...rowForm };
            isView && editSaveHandler(basicForm,rowForm,{
                isBasicFieldsChanged:false,
                isContactsChanged:false,
                isBranchMappingChanged:true
            })
            setBranchMappingRows(tempList);
        }
        listRef.current.stopEditing();

    }
    return (
        <Card>
            <CardBody>
                <div className='d-flex justify-content-between align-items-center'>
                    <div className='dark-text label-color'>Branch Mapping</div>
                    <div className='d-flex justify-content-between align-items-center' style={{ gap: '8px' }}>
                        {(userPermissions?.includes("C") || userPermissions?.includes("U"))&&open&&<div className='color-dark  p-2 br-8 cursor' style={{ fontSize: '45px', border: '1px solid #EEEEEE' }} onClick={() => listRef?.current?.addNewRow()} >+</div>}
                        <div className='  p-2 br-8 cursor' style={{ border: '1px solid #EEEEEE' }} onClick={() => { setOpen((prev) => (!prev));setRowForm({}) }}>{open ? <Uparrow /> : <DownArrow />}</div>
                    </div>
                </div>
                {open && <><div className='mt-24 mx-0' style={{ borderBottom: " 1px solid #E2E2E2" }}></div>
                    <BranchMappingListing ref={listRef}
                        rows={branchMappingRows}
                        //   loader={loader}
                        //   dropdown={dropdownData}
                        createHandler={createHandler}
                        updateHandler={updateHandler}
                        //deleteHandler={deleteHandler}
                        currentPage={currentPage}
                        rowCount={rowCount}
                        isNew={isNew}
                        setIsNew={setIsNew}
                        dropdown={dropdown}
                        buDropdown={tempBuDropdown}
                        rowForm={rowForm}
                        setRowForm={setRowForm}
                    />
                </>
                }

            </CardBody>
        </Card>
    )
}
export default BranchMapping